<template>
  <tr class="group">
    <slot />
  </tr>
</template>

<script setup lang="ts"></script>
